import { makeStyles } from "../../../providers/makeStyles";
import { useMenuState } from "../../../../hooks/useMenuState";
import { IconButton, Menu, MenuItem, Stack, Typography } from "@mui/material";
import { T } from "../../../util/t";
import { Add, Check, Close, ExpandMore } from "@mui/icons-material";
import { useTeamRoleStyles } from "./useTeamRoleStyles";
import classnames from "classnames";

const useStyles = makeStyles((theme, { disabled }) => ({
    pointer: {
        cursor: !disabled && "pointer",
    },
    role: {
        alignItems: "center",
        justifyContent: "space-between",
        width: theme.spacing(34.375)
    },
    checked: {
        marginRight: theme.spacing(.5),
    }
}));
export const  TeamMemberRoleMenu = ({ selectedTeamRole, teamRoles, assignedRoles, disabled, onUpdateTeamMemberRole }) => {
    const [anchorEl, openMenu, closeMenu] = useMenuState();
    const classes = { ...useTeamRoleStyles({ roleSelected: !!selectedTeamRole }), ...useStyles({ disabled }) };

    if (!teamRoles || teamRoles.length === 0) return null;

    const stopEvent = e => e.stopPropagation();
    const updateRole = role => {
        onUpdateTeamMemberRole(role);
        closeMenu();
    };

    return (
        <div className={classnames(classes.assign, classes.pointer)} onClick={stopEvent}>
            <Stack direction="row" alignItems="center" spacing={1} onClick={!disabled ? openMenu : undefined} className={classes.status}>
                {!selectedTeamRole ? <Add fontSize="small" /> : <ExpandMore fontSize="small" />}
                <Typography variant="label2" textTransform="uppercase">
                    <T>{(selectedTeamRole) || "Add role"}</T>
                </Typography>
            </Stack>

            <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={closeMenu}>
                {teamRoles.map(role => {
                    const isSelected = selectedTeamRole === role.name;
                    const isAssigned = !isSelected && assignedRoles?.includes(role.id);

                    return (
                        <MenuItem key={role.id} onClick={() => updateRole(role)} disabled={isAssigned} aria-disabled={isAssigned}>
                            <Stack direction="row"  className={classes.role}>
                                <Typography variant="body1">{role.name}</Typography>
                                {isSelected ?
                                    <IconButton size="small" onClick={e => { e.stopPropagation(); updateRole(null); }}><Close /></IconButton> :
                                    isAssigned && <Stack direction="row" spacing={.5}>
                                        <Typography variant="body1"><T>Already added</T></Typography>
                                        <Check color="success" aria-label="role-already-added" fontSize="small"/>
                                    </Stack>
                                }
                            </Stack>
                        </MenuItem>
                    );
                })}
            </Menu>
        </div>
    );
};
